import React, { useState } from "react";
import { uploadCustomerPicture, removeCustomerPicture, getSchedulingErrorMessage } from "../../../api/schedulingApi";
import CustomerPictureInput from "./CustomerPictureInput";
import { Alert, Modal, btnPrimary, btnSecondary } from "./ui";

export default function CustomerPictureModal({ customer, botId, onClose, onSaved }) {
  const [file, setFile] = useState(null);
  const [removed, setRemoved] = useState(false);
  const [cropping, setCropping] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const save = async () => {
    if (saving || cropping || (!file && !removed)) return;
    setSaving(true); setError("");
    try {
      const updated = file ? await uploadCustomerPicture(botId, customer.id, file)
        : await removeCustomerPicture(botId, customer.id);
      onSaved(updated); onClose();
    } catch (err) {
      setError(getSchedulingErrorMessage(err, "Could not update profile picture."));
    } finally { setSaving(false); }
  };
  return <Modal open title="Update profile picture" onClose={() => { if (!saving) onClose(); }}>
    <p className="text-sm text-slate-600">{customer.name || "Customer"}</p>
    <Alert>{error}</Alert>
    <fieldset disabled={saving}>
      <CustomerPictureInput customer={customer} botId={botId} file={file} removed={removed}
        onBusyChange={setCropping} onChange={(next, remove) => { setFile(next); setRemoved(remove); setError(""); }} />
    </fieldset>
    <div className="flex justify-end gap-2">
      <button type="button" className={btnSecondary} disabled={saving} onClick={onClose}>Cancel</button>
      <button type="button" className={btnPrimary} disabled={saving || cropping || (!file && !(removed && customer.profile_picture_file_id))}
        onClick={save}>{saving ? "Saving..." : "Save picture"}</button>
    </div>
  </Modal>;
}
